import { createContext, useState, useEffect, useCallback } from "react";
import axios from "../utils/axiosInstance";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {

  const [cartItems, setCartItems] = useState([]);

  /* ===============================
     LOAD CART
  =============================== */
  const loadCart = useCallback(async () => {

    const token = localStorage.getItem("token");
    if (!token) return;

    try {

      const res = await axios.get("/api/cart", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (Array.isArray(res.data)) {
        setCartItems(res.data);
      } else if (Array.isArray(res.data?.items)) {
        setCartItems(res.data.items);
      } else {
        setCartItems([]);
      }

    } catch (error) {
      console.error("Error fetching cart:", error);
    }

  }, []);

  /* ===============================
     LOAD ON START
  =============================== */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    loadCart();
  }, [loadCart]);

  /* ===============================
     ADD TO CART (FIXED)
  =============================== */
  const addToCart = async (variantId) => {

    console.log("ADD TO CART → Variant ID:", variantId); // 🔥 DEBUG

    const token = localStorage.getItem("token");

    if (!token) {

      return;

    }

    if (!variantId) {
      alert("Please select a size / variant");
      return;
    }

    try {

      await axios.post(
        `/api/cart/${variantId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      await loadCart();
      return true;

    } catch (error) {

      console.error("Error adding to cart:", error);

      alert(
        error?.response?.data ||
        "Could not add item to cart"
      );
    }
  };

  /* ===============================
     REMOVE (FIXED)
  =============================== */
  const removeFromCart = async (cartItemId) => {

    const token = localStorage.getItem("token");

    try {

      await axios.delete(`/api/cart/${cartItemId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setCartItems((items) =>
        items.filter((item) => item.id !== cartItemId)
      );

    } catch (error) {

      console.error("Error removing cart item:", error);
      alert("Could not remove item from cart");

    }
  };

  /* ===============================
     UPDATE QUANTITY
  =============================== */
  const increaseQuantity = async (cartItemId, currentQty) => {

    const token = localStorage.getItem("token");

    try {

      await axios.put(
        `/api/cart/update/${cartItemId}?quantity=${currentQty + 1}`,
        null,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      await loadCart();

    } catch (err) {
      console.error(err);
    }
  };

  const decreaseQuantity = async (cartItemId, currentQty) => {

    const token = localStorage.getItem("token");

    try {

      await axios.put(
        `/api/cart/update/${cartItemId}?quantity=${currentQty - 1}`,
        null,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      await loadCart();

    } catch (err) {
      console.error(err);
    }
  };

  /* ===============================
     CLEAR CART
  =============================== */
  const clearCart = () => {
    setCartItems([]);
  };

  /* ===============================
     PROVIDER
  =============================== */
  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        increaseQuantity,
        decreaseQuantity,
        refreshCart: loadCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
};